<template>
  <div class="record-list-print-header row justify-content-between m-0 pb-4">
    <div class="record-list-print-header__info">
      <div class="record-list-print-header__logo">
        <img
          src="@/assets/images/logo.png"
          class="record-list-print-header__logo-icon">
        <img
          src="@/assets/images/today_text.svg"
          class="record-list-print-header__logo-text">
      </div>
      <div class="record-list-print-header__export-date">
        [出力日時] {{ exportDate }}
      </div>
      <div class="record-list-print-header__user-name">
        [出力者] {{ user.name }}
      </div>
    </div>
    <div
      class="record-list-print-header__title flex-grow-1 text-center"
      data-testid="print-header-title">
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapState } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    exportDate() {
      return format(new Date(), 'yyyy/M/d H:mm')
    },
  },
}
</script>

<style lang="scss" scoped>
.record-list-print-header {
  align-items: flex-start;

  &__logo {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    &-icon {
      height: 40px;
    }

    &-text {
      height: 24px;
    }
  }

  &__export-date,
  &__user-name {
    color: $grey05;
    font-size: $fs-s;
  }

  &__title {
    font-size: $fs-lg;
    font-weight: bold;
  }
}
</style>
